/* eslint-disable */


/**
 * Create styles for `<AccountPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<AccountPage />` styles
 */
const accountPageStyles = ({ theme }) => {
  return {
    container: {
      height: `100%`,
    },
    dialogActions: {
      height: 36,
      padding: `0 ${theme.spacing(1) * 2}px ${theme.spacing(1)}px 0`,
    },
    error: {
      backgroundColor: theme.palette.error.dark,
      opacity: 0.9,
    },
    group: {
      display: `inline-block`,
    },
    icon: {
      fontSize: 20,
      marginRight: theme.spacing(1),
      verticalAlign: `text-bottom`,
    },
    inviteUserButton: {
      marginLeft: theme.spacing(1) * 2,
    },
    label: {
      color: theme.palette.grey[500],
      fontSize: theme.spacing(1) * 1.6,
    },
    message: {
      alignItems: `center`,
      display: `flex`,
    },
    snackbar: {
      zIndex: 99999999,
    },
    userListWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  };
};

export default accountPageStyles;
